/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createTopic = /* GraphQL */ `
  mutation CreateTopic(
    $input: CreateTopicInput!
    $condition: ModelTopicConditionInput
  ) {
    createTopic(input: $input, condition: $condition) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const updateTopic = /* GraphQL */ `
  mutation UpdateTopic(
    $input: UpdateTopicInput!
    $condition: ModelTopicConditionInput
  ) {
    updateTopic(input: $input, condition: $condition) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const deleteTopic = /* GraphQL */ `
  mutation DeleteTopic(
    $input: DeleteTopicInput!
    $condition: ModelTopicConditionInput
  ) {
    deleteTopic(input: $input, condition: $condition) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $input: DeleteMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    deleteMessage(input: $input, condition: $condition) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const createDomainUser = /* GraphQL */ `
  mutation CreateDomainUser(
    $input: CreateDomainUserInput!
    $condition: ModelDomainUserConditionInput
  ) {
    createDomainUser(input: $input, condition: $condition) {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateDomainUser = /* GraphQL */ `
  mutation UpdateDomainUser(
    $input: UpdateDomainUserInput!
    $condition: ModelDomainUserConditionInput
  ) {
    updateDomainUser(input: $input, condition: $condition) {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteDomainUser = /* GraphQL */ `
  mutation DeleteDomainUser(
    $input: DeleteDomainUserInput!
    $condition: ModelDomainUserConditionInput
  ) {
    deleteDomainUser(input: $input, condition: $condition) {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createDepartment = /* GraphQL */ `
  mutation CreateDepartment(
    $input: CreateDepartmentInput!
    $condition: ModelDepartmentConditionInput
  ) {
    createDepartment(input: $input, condition: $condition) {
      domainId
      department_id
      name
      user_defined_key
      order
      parent
      node
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateDepartment = /* GraphQL */ `
  mutation UpdateDepartment(
    $input: UpdateDepartmentInput!
    $condition: ModelDepartmentConditionInput
  ) {
    updateDepartment(input: $input, condition: $condition) {
      domainId
      department_id
      name
      user_defined_key
      order
      parent
      node
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteDepartment = /* GraphQL */ `
  mutation DeleteDepartment(
    $input: DeleteDepartmentInput!
    $condition: ModelDepartmentConditionInput
  ) {
    deleteDepartment(input: $input, condition: $condition) {
      domainId
      department_id
      name
      user_defined_key
      order
      parent
      node
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createNotifications = /* GraphQL */ `
  mutation CreateNotifications(
    $input: CreateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    createNotifications(input: $input, condition: $condition) {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
export const updateNotifications = /* GraphQL */ `
  mutation UpdateNotifications(
    $input: UpdateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    updateNotifications(input: $input, condition: $condition) {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotifications = /* GraphQL */ `
  mutation DeleteNotifications(
    $input: DeleteNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    deleteNotifications(input: $input, condition: $condition) {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
export const createIconReaction = /* GraphQL */ `
  mutation CreateIconReaction(
    $input: CreateIconReactionInput!
    $condition: ModelIconReactionConditionInput
  ) {
    createIconReaction(input: $input, condition: $condition) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const updateIconReaction = /* GraphQL */ `
  mutation UpdateIconReaction(
    $input: UpdateIconReactionInput!
    $condition: ModelIconReactionConditionInput
  ) {
    updateIconReaction(input: $input, condition: $condition) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const deleteIconReaction = /* GraphQL */ `
  mutation DeleteIconReaction(
    $input: DeleteIconReactionInput!
    $condition: ModelIconReactionConditionInput
  ) {
    deleteIconReaction(input: $input, condition: $condition) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const createDomainSettings = /* GraphQL */ `
  mutation CreateDomainSettings(
    $input: CreateDomainSettingsInput!
    $condition: ModelDomainSettingsConditionInput
  ) {
    createDomainSettings(input: $input, condition: $condition) {
      id
      createTopicAuthorityGroupPolicy {
        admin
        user
      }
      updateTopicAuthorityGroupPolicy {
        admin
        user
      }
      attachmentPolicy
      attachmentFileType {
        image
        movie
        pdf
        office
      }
      downloadPolicy
      downloadDeviceType {
        web
        ios
        android
        desktop
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateDomainSettings = /* GraphQL */ `
  mutation UpdateDomainSettings(
    $input: UpdateDomainSettingsInput!
    $condition: ModelDomainSettingsConditionInput
  ) {
    updateDomainSettings(input: $input, condition: $condition) {
      id
      createTopicAuthorityGroupPolicy {
        admin
        user
      }
      updateTopicAuthorityGroupPolicy {
        admin
        user
      }
      attachmentPolicy
      attachmentFileType {
        image
        movie
        pdf
        office
      }
      downloadPolicy
      downloadDeviceType {
        web
        ios
        android
        desktop
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteDomainSettings = /* GraphQL */ `
  mutation DeleteDomainSettings(
    $input: DeleteDomainSettingsInput!
    $condition: ModelDomainSettingsConditionInput
  ) {
    deleteDomainSettings(input: $input, condition: $condition) {
      id
      createTopicAuthorityGroupPolicy {
        admin
        user
      }
      updateTopicAuthorityGroupPolicy {
        admin
        user
      }
      attachmentPolicy
      attachmentFileType {
        image
        movie
        pdf
        office
      }
      downloadPolicy
      downloadDeviceType {
        web
        ios
        android
        desktop
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAllowFeature = /* GraphQL */ `
  mutation CreateAllowFeature(
    $input: CreateAllowFeatureInput!
    $condition: ModelAllowFeatureConditionInput
  ) {
    createAllowFeature(input: $input, condition: $condition) {
      keyword
      releasePhase
      desc
      updatedAt
      createdAt
    }
  }
`;
export const updateAllowFeature = /* GraphQL */ `
  mutation UpdateAllowFeature(
    $input: UpdateAllowFeatureInput!
    $condition: ModelAllowFeatureConditionInput
  ) {
    updateAllowFeature(input: $input, condition: $condition) {
      keyword
      releasePhase
      desc
      updatedAt
      createdAt
    }
  }
`;
export const deleteAllowFeature = /* GraphQL */ `
  mutation DeleteAllowFeature(
    $input: DeleteAllowFeatureInput!
    $condition: ModelAllowFeatureConditionInput
  ) {
    deleteAllowFeature(input: $input, condition: $condition) {
      keyword
      releasePhase
      desc
      updatedAt
      createdAt
    }
  }
`;
